export default "__VITE_ASSET__CL2n7wQD__"